/**
 * Convert a storage URI to an HTTP URL for serving files.
 * 
 * @param storageUri - The storage URI (e.g., "local://guidelines/images/file.png")
 * @returns The HTTP URL to access the file (e.g., "/api/v1/storage/guidelines/images/file.png")
 */
export function storageUriToUrl(storageUri: string | null | undefined): string | null {
  if (!storageUri) return null;
  return `/api/v1/guidelines/storage/download?uri=${storageUri}`;
}

/**
 * Get the full URL for a storage URI using the orchestrator base URL.
 * 
 * @param storageUri - The storage URI (e.g., "local://guidelines/images/file.png")
 * @param baseUrl - The base URL of the orchestrator (defaults to REACT_APP_ORCHESTRATOR_URL)
 * @returns The full HTTP URL including the base
 */
export function storageUriToFullUrl(
  storageUri: string | null | undefined, 
  baseUrl?: string
): string | null {
  const path = storageUriToUrl(storageUri);
  if (!path) return null;
  
  const base = baseUrl || process.env.REACT_APP_STATIC_INFERENCE_API_URL || '';
  return `${base}${path}`;
}
